import { getRequest } from "../../utils/request";

export const getCustomerUsers = (organizationId) => {
  let url = `/v1/users/management?organizationId=${organizationId}`;
  return getRequest(url);
};
